import { Component, Input } from '@angular/core'

@Component({
  selector: 'jml-lib-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss']
})
export class ProgressComponent {
  @Input() value: number = 0
}
